<template>
  <div>
    <Modal title="Book Thanksgiving" @click.prevent="toggleModal">
      <div slot="body">
        <div class="row mt-4">
          <div class="form-group col-md-6 col-sm">
            <label for="first-name">First name</label>
            <input type="text" id="first-name" placeholder="" class="form-control"
              v-model="userDetails.firstName">
          </div>

          <div class="form-group col-md-6 col-sm">
            <label for="last-name">Last name</label>
            <input type="text" id="last-name" placeholder="" class="form-control"
              v-model="userDetails.lastName">
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6 col-sm">
            <label for="email-address">Email Address</label>
            <input type="text" id="email-address" placeholder="e.g example@mail.com"
              class="form-control" v-model="userDetails.email">
          </div>

          <div class="form-group col-md-6 col-sm">
            <label for="phone-number">Phone Number</label>
            <input type="text" id="phone-number" placeholder="" class="form-control"
              v-model="userDetails.phoneNumber">
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6 col-sm">
            <label for="date">Thanksgiving Date</label>
             <!-- <input type="text" id="date" placeholder="" class="form-control"
              v-model="userDetails.thanksgivingDate"> -->
               <date-picker v-model="userDetails.thanksgivingDate" lang="en" type="date" format="DD/MM/YYYY" :disabled-date="(date) => date < new Date()" :editable= false> </date-picker>
          </div>

          <div class="form-group col-md-6 col-sm">
            <label for="mass-time">Mass time</label>
              <date-picker v-model="userDetails.massTime" lang="en" type="time" :format="'hh:mm a'"
                                     :timePickerOptions='userDetails.timePickerOptions'> </date-picker>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-md-12 col-sm">
            <label for="reason">Thanking God for?</label>
            <textarea  id="reason" cols="2" rows="2" class="form-control" v-model="userDetails.reason"></textarea>

          </div>

        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="toggleModal">Close</button>
          <button type="button" class="btn btn-primary" @click="bookThanksgiving">Submit</button>
        </div>



      </div>

    </Modal>

  </div>
</template>

<script>
import axios from 'axios';
import Modal from '@/components/modal/Modal.vue';
export default {
  data() {
    return {
      userDetails: {
        firstName: '',
        lastName: '',
        massTime: '',
        email: '',
        reason: '',
        phoneNumber: '',
        thanksgivingDate: '',
        timePickerOptions: {
          start: '06:00',
          step: '00:30',
          end: '23:00'
        },
         disabledDates: {
            to: new Date(Date.now() - 8640000)
        }
      }
    }
  },
  components: {
    Modal
  },
  methods: {
    toggleModal() {
      this.$emit('close')
      this.userDetails.firstName = ''
      this.userDetails.lastName = ''
      this.userDetails.massTime = ''
      this.userDetails.email = ''
      this.userDetails.reason = ''
      this.userDetails.phoneNumber = ''
      this.userDetails.thanksgivingDate = ''
    },
    closeModalWithEscape() {
      document.addEventListener("keydown", (e) => {
        if (this.isVisible == true && e.keyCode == 27) {
          this.toggleModal();
        }
      });
    },

    async bookThanksgiving() {
      try {
        const response = await axios.post(`/mass/thanksgiving`, JSON.stringify(this.userDetails));
        const data = await response;
        console.log(data);
         if (data.data.status) {
           this.toggleModal()
         this.$swal(data.data.message,
           'God bless you abundantly',
           'success');
       }
      } catch (error) {
        console.error("error", error);
      }
    }
  },
}
</script>

<style scoped>
.mx-datepicker {
    position: relative;
    display: block;
    width: 100%;
    height: calc(1.5em + .75rem + 2px);
    /* padding: .375rem .75rem !important; */
}

.mx-input {
    padding: .375rem .75rem !important;
}

.form-group input:focus, textarea:focus{
     outline:0px !important;
     box-shadow: none !important;
 }
</style>
